import React from 'react';
import "../styles/Footer.css";

export const Footer = () => {
  return (
    <footer className='footer'>
      &copy; 2021-2022 <br />
      LectoPoint
    </footer>
  )
}
